export default class Accordion {
	constructor(id) {
		this.id = id;
		this.$root = null;
		this.$cardCollection = null;

		this.init();
	}

	init() {
		this.getElements();
		this.addItemCollapsingHandler();
	}

	getElements() {
		this.$root = document.getElementById(this.id);
		this.$cardCollection = this.$root.querySelectorAll('.accordion-card');
	}

	addItemCollapsingHandler() {
		this.$cardCollection.forEach($card => {
			if (!$card.querySelector('.accordion-card-collapse')) return;

			$card.addEventListener('click', e => {
				const $header = e.target.closest('.accordion-card-header');
				const $targetedCard = $header ? $header.closest('.accordion-card') : null;

				this.closeOpened($targetedCard);
				this.toggle($card);
			});
		});
	}

	closeAllAndOpen($card) {
		const $openedCardCollection = this.$root.querySelectorAll('.accordion-card.-expanded');
		$openedCardCollection.forEach($openedCard => {
			const $collapsed = $openedCard.querySelector('.accordion-card-collapse');
			this.close($openedCard, $collapsed);
		});

		const $collapsed = $card.querySelector('.accordion-card-collapse');
		this.open($card, $collapsed);
	}

	toggle($card) {
		const $collapsed = $card.querySelector('.accordion-card-collapse');

		if (!$collapsed.style.maxHeight) {
			this.open($card, $collapsed);
		} else {
			this.close($card, $collapsed);
		}
	}

	open($card, $collapsed) {
		const $cardBody = $collapsed.querySelector('.accordion-card-body');
		const cardHeight = $cardBody.offsetHeight;
		$collapsed.style.maxHeight = cardHeight + 'px';
		$card.classList.add('-expanded');
	}

	close($card, $collapsed) {
		$collapsed.style.maxHeight = null;
		$card.classList.remove('-expanded');
	}

	closeOpened($targetedCard) {
		const $openedCardCollection = this.$root.querySelectorAll('.accordion-card.-expanded');
		$openedCardCollection.forEach($card => {
			if ($card !== $targetedCard) {
				const $collapsed = $card.querySelector('.accordion-card-collapse');
				this.close($card, $collapsed);
			}
		});
	}
}